import { MerchantWalletBalanceRequest, Wallets } from "../../../models/FinancialData";
import { CalculateMoneyTransferChargeRequest, CardOperationInitiateResponse, DepositMoneyFromExistingCardPaymentMethodUserRequest, MoneyTransferChargeResponse, PointToPointMoneyTransferRequestModel, WithdrawToAnyIBANMoneyTransferRequest } from "../../../models/MoneyTransferModal";
import { Result } from "../../../models/Result";
import { httpService } from "../../HttpService";

class MerchantPaymentApiService {
    path: string = "MerchantPayment";

    getMoneyTransferCharge = async (model: CalculateMoneyTransferChargeRequest): Promise<Result<MoneyTransferChargeResponse>> =>
		await httpService.post<MoneyTransferChargeResponse>(`/${this.path}/get-money-transfer-charge`, model);

     toEndUserMoneyTransfer = async (sourceOperatorId: number, beneficiaryIndividualId: number, model: PointToPointMoneyTransferRequestModel): Promise<Result<string>> =>
       await httpService.post<string>(`/${this.path}/source-operatorId/${sourceOperatorId}/beneficiary-individualId/${beneficiaryIndividualId}/p2p-money-transfer`, model);

    // toAnyIbanWithdrawal = async (sourceOperatorId: number, model: WithdrawToAnyIBANMoneyTransferRequest): Promise<Result<string>> =>
    //   await httpService.post<string>(`/${this.path}/${sourceOperatorId}/withdrawal-to-3rd-party-iban`, model);

    depositMoneyFromPaymentMethod3DAsync = async (merchantId: number, model: DepositMoneyFromExistingCardPaymentMethodUserRequest): Promise<Result<CardOperationInitiateResponse>> =>
      await httpService.post<CardOperationInitiateResponse>(`${this.path}/${merchantId}/deposit-money-from-existing-card-payment-method-3d-initiate`, model);
  
    depositMoneyFromNewCardAsync = async (merchantId: number, model: DepositMoneyFromExistingCardPaymentMethodUserRequest): Promise<Result<CardOperationInitiateResponse>> =>
      await httpService.post<CardOperationInitiateResponse>(`${this.path}/deposit-money-from-new-card-payment-method-initiate/${merchantId}`, model);

  }

const merchantPaymentApiService = new MerchantPaymentApiService();

export { merchantPaymentApiService };